module.exports = {"API-ENDPOINT":"https://services.myanatomy.in:8443"}


//////////////////
// WEBPACK FOOTER
// ./src/conf/config-dev.json
// module id = 586
// module chunks = 0